<template>
  <footer
    id="contact"
    class="bg-primary-light dark:bg-secondary-dark sm:border-t sm:border-gray-100 sm:dark:border-white/5"
  >
    <div class="container mx-auto px-6 pb-20 pt-24 md:py-24">
      <div class="mx-auto max-w-2xl text-center">
        <p v-reveal class="reveal-up font-mono text-sm tracking-[0.3em] text-jelly-500">
          GET IN TOUCH
        </p>
        <h2
          v-reveal
          class="reveal-up mt-3 font-general-bold text-[clamp(1.9rem,5vw,3rem)] leading-tight text-primary-dark dark:text-primary-light"
        >
          Let's build something together.
        </h2>
        <a
          v-reveal
          :href="`mailto:${profile.contact.email}`"
          class="reveal-up mt-7 inline-flex items-center gap-2 rounded-xl bg-jelly-500 px-7 py-3.5 font-general-medium text-white shadow-lg shadow-jelly-500/30 transition-all duration-300 hover:-translate-y-0.5 hover:bg-jelly-600"
        >
          <CustomIcon name="mail" class="h-5 w-5" />
          Say hello
        </a>
      </div>

      <ul
        class="mx-auto mt-12 flex max-w-xl flex-col items-center justify-center gap-4 text-ternary-dark dark:text-ternary-light sm:flex-row sm:gap-8"
      >
        <li>
          <a :href="`mailto:${profile.contact.email}`" class="contact-link">
            <CustomIcon name="mail" class="h-4 w-4" />
            {{ profile.contact.email }}
          </a>
        </li>
        <li>
          <a :href="`tel:${profile.contact.phone}`" class="contact-link">
            <CustomIcon name="phone" class="h-4 w-4" />
            {{ profile.contact.phone }}
          </a>
        </li>
        <li class="contact-link">
          <CustomIcon name="map-pin" class="h-4 w-4" />
          {{ profile.contact.location }}
        </li>
      </ul>

      <ul class="mt-10 flex items-center justify-center gap-3">
        <li v-for="social in socials" :key="social.name">
          <a
            :href="social.url"
            target="_blank"
            rel="noopener"
            :aria-label="social.name"
            class="grid h-11 w-11 place-items-center rounded-full bg-secondary-light text-ternary-dark shadow-sm transition-all duration-300 hover:-translate-y-1 hover:text-jelly-500 dark:bg-ternary-dark dark:text-ternary-light"
          >
            <CustomIcon :name="social.icon" class="h-5 w-5" />
          </a>
        </li>
      </ul>

      <p class="mt-12 text-center text-sm text-gray-400">
        Designed and built by {{ profile.name }}. &copy; {{ year }}
      </p>
    </div>
  </footer>
</template>

<script setup>
import CustomIcon from '@/components/base/CustomIcon.vue';
import { profile } from '@/constants/profile';
import { socials } from '@/constants/socials';

const year = new Date().getFullYear();
</script>

<style scoped lang="scss">
.contact-link {
  align-items: center;
  display: inline-flex;
  gap: 0.5rem;
  transition: color var(--dur-fast) ease;

  @media (hover: hover) {
    &:hover {
      @apply text-jelly-500;
    }
  }
}
</style>
